export default __webpack_public_path__ + "static/media/meeting.323789ed.png";